import { useState, useEffect, forwardRef } from 'react';
import TeamTable from './TeamTable'
import { Paper, TableBody, makeStyles, TableCell, TableRow, IconButton, Modal, FormControl, Select, InputLabel, MenuItem } from '@material-ui/core';
import axios from 'axios';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert'
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  TextField
} from '@material-ui/core';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core'
import { useHistory } from 'react-router';
import './Teams.css';
import Cookies from 'universal-cookie';

const Teams = (props) => {
  const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });
  const useStyles = makeStyles(theme => ({
    pageContent: {
      margin: theme.spacing(5),
      padding: theme.spacing(3),

    },
    searchInput: {
      width: '75%'
    },
    addButton: {
      height: '8vh',
      width: '20vw',
      margin: theme.spacing(1),
    },
    createButtons: {
      marginTop: '5vh',
      marginLeft: '25vw',
      display: 'flex',
      width: '50vw',
      height: '10vh',
      placeItems: 'center',
      justifyContent: 'center',
    },
    modalTeam: {
      position: 'absolute',
      width: 400,
      backgroundColor: 'white',
      border: '2px solid #000',
      boxShadow: theme.shadows[5],
      //padding: '16px 32px 24px',
      padding: theme.spacing(2, 4, 3, 4),
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
    },
    buttonModified: {
      margin: theme.spacing(1),
    }

  }))
  const cookies = new Cookies();
  const userToken = cookies.get('tokenCTF');
  const classes = useStyles();
  const [records, setRecords] = useState([])
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [nameJoin, setNameJoin] = useState('');
  const [passwordJoin, setPasswordJoin] = useState('');
  const [description, setDescription] = useState([]);
  const [openRemoveDialogUser, setOpenRemoveDialogUser] = useState(false);
  const [haveTeam, setHaveTeam] = useState(false);
  const [modalAddTeam, setModalAddTeam] = useState(false);
  const [modalJoinTeam, setModalJoinTeam] = useState(false);
  const [captain, setCaptain] = useState(false);
  const [captainID, setCaptainID] = useState(0);
  const [modalChangeCaptain, setModalChangeCaptain] = useState(false);
  const [captainName, setCaptainName] = useState('');
  const [usersCaptain, setUsersCaptain] = useState([]);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [openError, setOpenError] = useState(false);
  const [error, setErrorMessage] = useState('');
  const [success, setSuccessMessage] = useState('');
  const history = useHistory();
  const headCells = [
    { id: 'equipo', label: 'Equipo' },
    { id: 'puntaje', label: 'Puntaje' },
  ]
  const handleClose = () => {
    setOpenError(false);
    setOpenSuccess(false);
  };
  const {
    TblContainer,
    TblHead,
    TblPagination,
    recordsAfterPagingAndSorting
  } = TeamTable(records, headCells);
  const openCloseModalAdd = () => {
    setModalAddTeam(!modalAddTeam);
  }
  const openCloseModalJoin = () => {
    setModalJoinTeam(!modalJoinTeam);
  }
  const handleModalChangeCaptain = () => {
    setModalChangeCaptain(!modalChangeCaptain);
  }
  function handleOpenRemoveDialogUser() {
    setOpenRemoveDialogUser(!openRemoveDialogUser);

  };
  
  useEffect(() => {


    axios.get(`https://${process.env.REACT_APP_BASE_URL}/api/teams/getTeam`, {
      headers: { 'Authorization': userToken }
    }).then((response) => {
      if (response.data.noAuth) {
        cookies.remove('tokenCTF', { path: '/' });
        history.push('/login');
      }
      else {
        setDescription(response.data);

        if (response.data[0].team === true) {
          setHaveTeam(true);
        }
      }

    });

    if (haveTeam) {
      axios.get(`https://${process.env.REACT_APP_BASE_URL}/api/teams/getMembers`, {
        headers: { 'Authorization': userToken }
      }).then((response) => {
        if (response.data.noAuth) {
          cookies.remove('tokenCTF', { path: '/' });
          history.push('/login');
        }
        else {
        setRecords(response.data);
        teamList();
        axios.get(`https://${process.env.REACT_APP_BASE_URL}/api/teams/getCaptain`, {
          headers: { 'Authorization': userToken }
        }).then((response2) => {
          if (response2.data.noAuth) {
            cookies.remove('tokenCTF', { path: '/' });
            history.push('/login');
          }
          else {
          setCaptain(response2.data.isCaptain);
          setCaptainID(response2.data.captain);
          }
        });}

      });
    }

  }, [haveTeam, captain]);

  const onSubmit = () => {
    axios.post(`https://${process.env.REACT_APP_BASE_URL}/api/teams/createTeam`, {
      name: name,
      password: password,
    }, {
      headers: { 'Authorization': userToken }
    }).then((response) => {
      if (response.data.noAuth) {
        cookies.remove('tokenCTF', { path: '/' });
        history.push('/login');
      }
      else {
      if (response.data.messageSuccess) {
        setHaveTeam(true);
        setSuccessMessage(response.data.messageSuccess);
        setOpenSuccess(true);
        openCloseModalAdd();
      }
      else if (response.data.messageError) {
        setErrorMessage(response.data.messageError);
        setOpenError(true);
      }
      else {
        setOpenError(false);
        setOpenSuccess(false);
        setErrorMessage('');
        setSuccessMessage('');
      }}
    });
  };
  const onSubmitJoin = () => {
    axios.post(`https://${process.env.REACT_APP_BASE_URL}/api/teams/joinTeam`, {
      name: nameJoin,
      password: passwordJoin,
    }, {
      headers: { 'Authorization': userToken }
    }).then((response) => {
      if (response.data.noAuth) {
        cookies.remove('tokenCTF', { path: '/' });
        history.push('/login');
      }
      else {
      if (response.data.messageSuccess) {
        setHaveTeam(true);
        setSuccessMessage(response.data.messageSuccess);
        setOpenSuccess(true);
        openCloseModalJoin();
      }
      else if (response.data.messageError) {
        setErrorMessage(response.data.messageError);
        setOpenError(true);
        setHaveTeam(false);
      }
      else {
        setOpenError(false);
        setOpenSuccess(false);
        setErrorMessage('');
        setSuccessMessage('');
        setHaveTeam(false);
      }}
    });
  };
  const leaveTeam = () => {
    axios.put(`https://${process.env.REACT_APP_BASE_URL}/api/teams/leaveTeam`, {
      action: 'leave'
    }, {
      headers: { 'Authorization': userToken }
    }).then((response) => {
      if (response.data.noAuth) {
        cookies.remove('tokenCTF', { path: '/' });
        history.push('/login');
      }
      else {
      if (response.data.messageSuccess) {
        setSuccessMessage(response.data.messageSuccess);
        setOpenSuccess(true);
        setHaveTeam(false);
        handleOpenRemoveDialogUser();
      }
      else if (response.data.messageError) {
        setErrorMessage(response.data.messageError);
        setOpenError(true);
      }
      else {
        setOpenError(false);
        setOpenSuccess(false);
        setErrorMessage('');
        setSuccessMessage('');
      }}
    });
  };
  const onSubmitChangeCaptain = () => {
    axios.put(`https://${process.env.REACT_APP_BASE_URL}/api/teams/updateCaptain`, {
      newCaptain: captainName
    }, {
      headers: { 'Authorization': userToken }
    }).then((response) => {
      if (response.data.noAuth) {
        cookies.remove('tokenCTF', { path: '/' });
        history.push('/login');
      }
      else {
      if (response.data.messageSuccess) {
        setSuccessMessage(response.data.messageSuccess);
        setOpenSuccess(true);
        setModalChangeCaptain(false);
        setCaptain(false);
      }
      else if (response.data.messageError) {
        setErrorMessage(response.data.messageError);
        setOpenError(true);
      }
      else {
        setOpenError(false);
        setOpenSuccess(false);
        setErrorMessage('');
        setSuccessMessage('');
      }}
    });

  };

  const teamList = () => {
    let arrayUsers = [];
    for (let i = 0; i < records.length; i++) {
      arrayUsers.push(records[i].username);
    }
    setUsersCaptain(arrayUsers);

  }


  return (
    <div className="teams">
      {/* CREAR TEAM*/}
      <Card className="team-information">
        <CardContent>
          {description.map((team) => {
            return (
              <div className="title-team-info">
                <h1>{team.name}</h1>
                <h2>{team.score}</h2>
              </div>


            )
          })}
        </CardContent>
      </Card>
      <div className={ haveTeam ? "createButtons displayNone" : "createButtons"} >
        <Button className="addButton" onClick={() => openCloseModalAdd()} variant='contained'>Crear Equipo</Button>
        <Button className="addButton" onClick={() => openCloseModalJoin()} variant='contained'>Unirse a un Equipo</Button>
      </div>
      <Modal open={modalAddTeam} onClose={openCloseModalAdd}>
        <Card className="team-config" >
          <CardHeader
            title="Crea tu Equipo"
          />
          <Divider />
          <CardContent>
            <Grid
              container
              spacing={3}
            >
              <Grid
                item
                md={6}
                xs={12}
              >


                <TextField
                  fullWidth
                  label="Nombre de Equipo"
                  name="name"
                  required
                  variant="outlined"
                  onChange={(e) => {
                    setName(e.target.value)
                  }}
                />

              </Grid>

              <Grid
                item
                md={6}
                xs={12}
              >
                <TextField
                  fullWidth
                  label="Password del Equipo"
                  name="password"
                  type="password"
                  required
                  variant="outlined"
                  onChange={(e) => {
                    setPassword(e.target.value)
                  }}
                />
              </Grid>


            </Grid>
          </CardContent>
          <Divider />
          <Box
          className="boxStylingTeams"
          >
            <Button type='submit' variant="outlined" color="primary" className="buttonModified"
              onClick={onSubmit}>
              Crear
            </Button>
            <Button type='submit' variant="outlined" color="secondary" className="buttonModified"
              onClick={openCloseModalAdd}>
              Cancelar
            </Button>
          </Box>
        </Card>
      </Modal>
      {/* UNIRSE TEAM*/}
      <Modal open={modalJoinTeam} onClose={openCloseModalJoin}>
        <Card className="team-config" >
          <CardHeader
            title="Unirse a un equipo"
          />
          <Divider />
          <CardContent>
            <Grid
              container
              spacing={3}
            >
              <Grid
                item
                md={6}
                xs={12}
              >


                <TextField
                  fullWidth
                  label="Nombre de Equipo"
                  name="name"
                  required
                  variant="outlined"
                  onChange={(e) => {
                    setNameJoin(e.target.value)
                  }}
                />

              </Grid>

              <Grid
                item
                md={6}
                xs={12}
              >
                <TextField
                  fullWidth
                  label="Password del Equipo"
                  name="password"
                  type="password"
                  required
                  variant="outlined"
                  onChange={(e) => {
                    setPasswordJoin(e.target.value)
                  }}
                />
              </Grid>


            </Grid>
          </CardContent>
          <Divider />
          <Box
          className="boxStylingTeams"
          >
            <Button type='submit' variant="outlined" color="primary" className="buttonModified"
              onClick={onSubmitJoin}>
              Unirse
            </Button>
            <Button type='submit' variant="outlined" color="secondary" className="buttonModified"
              onClick={openCloseModalJoin}>
              Cancelar
            </Button>
          </Box>
        </Card>
      </Modal>
      {/* CAMBIAR CAPITAN*/}
      <Modal open={modalChangeCaptain} onClose={handleModalChangeCaptain}>
        <div className="modalTeam">
          <Card  >
            <CardHeader
              title="Cambiar Capitan"
            />
            <Divider />
            <CardContent>
              <Grid
                container
                spacing={3}
              >
                <Grid
                  item
                  md={6}
                  xs={12}
                >
                  <FormControl fullWidth>
                    <InputLabel id="captainSelect">Capitan</InputLabel>
                    <Select labelID="captainSelect" id="selectCaptain" value={captainName} label="Capitan" onChange={(e) => { setCaptainName(e.target.value) }}>
                      {usersCaptain.map((record) => {
                        return (
                          <MenuItem value={record}>{record}</MenuItem>
                        )
                      })}
                    </Select>

                  </FormControl>

                </Grid>

              </Grid>
            </CardContent>
            <Divider />
            <Box
            className="boxStylingTeams"
            >
              <Button type='submit' variant="contained"
                onClick={onSubmitChangeCaptain}>
                Cambiar
              </Button>
              <Button type='submit' variant="contained" className="buttonMargin"
                onClick={handleModalChangeCaptain}>
                Cancelar
              </Button>
            </Box>
          </Card>

        </div>
      </Modal>
      {/* TABLA*/}
      <div className="score-table">
        <Paper className={ haveTeam ? "pageContent" : "pageContent displayNone"}>
          <CardContent className="cardContentStyle">
            <div className="teamHeader-left">
              <h2>Miembros</h2>
            </div>
            <div className="teamHeader-right">
              <Button type='submit' variant="outlined" color='primary' className={ captain ? "" : "displayNone"} onClick={handleModalChangeCaptain}
              >
                CAPITAN
              </Button>
              <Button type='submit' variant="outlined" color='secondary'
                className="buttonMargin2"
                onClick={handleOpenRemoveDialogUser}>
                Salir del equipo
              </Button>
            </div>
          </CardContent>
          <TblContainer >
            <TblHead />
            <TableBody>
              {
                recordsAfterPagingAndSorting().map((item, index) => (

                  <TableRow key={index} >
                    <TableCell >{item.username}{(captainID === item.id) ? <span className="captain-button" >Capitán</span> : ""}</TableCell>
                    <TableCell >{item.score}</TableCell>



                  </TableRow>
                ))
              }

            </TableBody>
          </TblContainer>

        </Paper>
        <Dialog
          open={openRemoveDialogUser}
          onClose={handleOpenRemoveDialogUser}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"Abandonar equipo"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              ¿Está seguro que desea dejar el equipo?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={leaveTeam} >
              Sí
            </Button>
            <Button onClick={handleOpenRemoveDialogUser} autoFocus>
              No
            </Button>
          </DialogActions>
        </Dialog>
        <Snackbar open={openError} autoHideDuration={3000} onClose={handleClose}>
          <Alert onClose={handleClose} severity="error" className="alertStyling">
            {error}
          </Alert>
        </Snackbar>
        <Snackbar open={openSuccess} autoHideDuration={3000} onClose={handleClose}>
          <Alert onClose={handleClose} severity="success" className="alertStyling">
            {success}
          </Alert>
        </Snackbar>
      </div>

    </div>
  );

};

export default Teams;